// extracted by mini-css-extract-plugin
module.exports = {"comment":"BetonExpenseComments_comment__2gLcv","head":"BetonExpenseComments_head__PHQlu","content":"BetonExpenseComments_content__2zeQA"};